import React from 'react';
import { Workflow } from './types';
import { Tabs, TabsList, TabsTrigger } from '../../common/ui/Tabs';

export function WorkflowFilters({
  workflows,
  handleWorkflowChange,
  activeWorkflow,
}: {
  workflows: Workflow[],
  handleWorkflowChange: (workflowName: string) => void,
  activeWorkflow: string,
}) {
  return (
    <Tabs defaultValue={activeWorkflow}>
      <TabsList className="w-100">
        {workflows.map((workflow) => (
          <TabsTrigger
            key={workflow.name}
            value={workflow.name}
            onClick={() => handleWorkflowChange(workflow.name)}
          >
            {workflow.displayName}
          </TabsTrigger>
        ))}
      </TabsList>
    </Tabs>
  );
}
